import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

import { SelectSearchComponent } from './select-search.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatButtonModule } from '@angular/material/button';
/**
 * This is the module used for the form control Select Search
 * @exports
 * @class SelectSearchModule
 */
@NgModule({
  declarations: [SelectSearchComponent],
  imports: [
    FormsModule,
    CommonModule,
    MatSelectModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule,
    MatProgressBarModule,
    MatButtonModule
  ],
  exports: [SelectSearchComponent],
})
export class SelectSearchModule {}
